export enum AiCallType {
    TEST_AUTOMATION_READINESS_SCORE,
    DEFECT_SUMMARY,
    ISSUE_DESCRIPTION,
    ABAP_CODE_EXPLANATION,
    VIDEO_EVIDENCE_SUMMARY,
    UNIT_TEST_GUIDE,
    FIX_SUMMARY
}
